/*
///////////////////////////////////////////////////////////////////////

This template is part of EC-CUBE Design template.

Copyright(c) JAPAN ELECTRONIC INDUSTRIAL ARTS CO.LTD.

http://www.jeia.co.jp/

For the full copyright and license information, please view the LICENSE
file that was distributed with this source code.

本テンプレートの著作権は、「株式会社日本電子工藝社」に帰属いたします。

※本テンプレートを譲渡・再頒布・転用・第三者へ開示することは禁止いたします。
ただし、事業者によるショップ運営者への設置代行を禁止するものではございません。
※本テンプレートを申請されたご利用サイトへの設置以外の目的で複製することは禁止いたします。
※本テンプレートデータ内のライセンス条項、および著作権に関する記述を削除することはできません。
※ご利用サイトを変更することはできません。申請と異なるサイトにてご利用になる場合は、
別途、ご利用費用をお支払いただく必要がございます。
※本テンプレートの改変にあたり、一切のサポートはいたしかねます。
※本テンプレートは、すべての設置環境で動作する事は保証しておりません。

///////////////////////////////////////////////////////////////////////
*/
/*************************************************
 * Description: 動画スライダー
 * Update: 2020/08/05
 * version: 2.2
 * Notes:  
    スライダー表示タイプ【A】～【C】を選択できるように対応(ver.2)
    ver2.1 バグ修正
    ver2.2 ドットボタンをslick要素の外側に出すか否かを指定できるパラメータを追加
*************************************************/
/*
 * スライダーエリアのサイズ（縦横比率）は、デスクトップ時は動画比率から高さを決定し動画サイズにフィットさせます。モバイル時は少し大きめに高さを取る仕様です。
 *
 * 動画の自動再生は音声無しの仕様です。音声の出る状態での自動再生はブラウザ側でブロックされてしまいます（動画自体再生されない）。
 * 音声をON/OFFさせるボタンを付けましたので再生後は音声のON/OFFが可能です。スライドして次の動画に入ると音声はオフにリセットされます。←Google Chromeにて動作不安定なので機能をオフ
 */

if (window.jeia === undefined) {
	window.jeia = {};
}
var jeia = window.jeia;

$(function() {

	//
	jQuery.fn.jeia_movieslider = function(config) {

		// コンフィグ
		config = jQuery.extend({
			'base':          this,
			'sliderType':    'c',
			'sliderHeight':  700,//    スライダータイプ「C」の場合はこの高さを基準として各アイテムの幅が決定される
			'mainRatio':     16/9,//   動画縦横比率（=デスクトップ時・タブレット時のエリア表示縦横比率）
			'spRatio':       16/11,//  スマホ時のエリア表示縦横比率
			'autoplay':      true,//   スライド自動切り替え
			'autoplaySpeed': 15000,//  スライドの表示時間（ms）
			'speed':         800,//    スライド時間（移動時間）
			'soundSW':       true,//   音声ON/OFFボタンの有無
			'dotsOuter':     false,//  ドットボタンをslick要素の外側に出す場合はtrue
			'null':          null
		}, config);

		// 実行
		new JeiaMovieSlider(config);
	}

	//
	function JeiaMovieSlider(_config){
		this.config =        _config;
		this.$base =		 this.config[ 'base' ];
		this.$container =	 this.$base.find( '.ec-slickContainer' );
		this.$sliderItem =   null;
		this.$slickCurrent = null;
		this.$loader =       null;
		this.$soundBtn =     null;

		this.$caption = null;
		this.$captionCurrent = null;

		this.sliderType =    this.config[ 'sliderType' ];
		this.slideMaxWidth = this.config[ 'slideMaxWidth' ];
		this.sliderHeight =  this.config[ 'sliderHeight' ];
		this.mainRatio =     this.config[ 'mainRatio' ];
		this.spRatio =       this.config[ 'spRatio' ];
		this.slickCurrentMedia =  '';
		this.soundSW =       this.config[ 'soundSW' ];
		this.dotsOuter =     this.config[ 'dotsOuter' ];
		this.pauseOnHoverFlag = null;

		// class追加
		this.$base.addClass( 'ec-movieslider' );

		// loader生成
		this.fnMakeLoading();

		// SOUNDボタン生成
		this.fnMakeSoundBtn();

		// 全メディア要素のロード完了をチェック（※ロード確認はｊQueryの中では正確に取得できませんので、Twig側のJavascriptにて行っています）
		var self = this;
        mediaCheck();
		
        function mediaCheck() {
	        
	        // ページ読み込み完了、もしくは全メディア読み込み完了で開始
			// ※iPhoneではページ再読み込みしたときにキャッシュのせいかimg画像のロード確認が取れない事があったので、ページ読み込み完了（window.onload）を合わせて条件とします
			// ※window_loadedは、jeia_function.jsにて、ページ読み込み完了後にフラグがONされます。
	        if ( window_loaded || media_count_all == media_count ) {
				// 初期処理実行
				self.fnInit();
	        } else {
	        	// タイマーで準備待ち
	        	setTimeout(mediaCheck, 1000);
	        }
        }

		// グローバルに登録
		jeia.jeia_movieslider = this;
	}

	// fn:初期処理
	JeiaMovieSlider.prototype.fnInit = function(){
		var self = this;

		// slick init
		this.$container.on('init', function(e,slick){

			// 準備完了を確実にするための0タイマー（参考：https://github.com/kenwheeler/slick/issues/1802#issuecomment-293108442）
			setTimeout(function(){

				// スライダーitem要素を取得
				self.$sliderItem = self.$container.find( '.slick-slide' );

				// スライダーエリア高さを決定
				//self.fnBaseHeight();
				self.fnSetSize();

				// 1枚目のslickカレント要素の取得、メディア種類の取得
				self.$slickCurrent = self.$sliderItem.filter( '.slick-current' );
				self.slickCurrentMedia = self.$slickCurrent.data( 'media' );

				// キャプション全要素取得
				self.$caption = self.$sliderItem.find( '.mediaCaption' );

				// キャプションcloseボタン
				self.$caption.find( '.inner' ).append( $('<div class="closeBtn">') );
				self.$caption.find( '.closeBtn' ).on('click', function(e){
					e.preventDefault();// 画像プロモーションではアイテム全体にa要素がかかっている場合があるのでイベント伝播を防いでおきます
					self.$caption.toggleClass( 'is-close' );
				});

				// スマホ時は、キャプションが表示されたあとタイマー後に閉じておきます
				if ( window.innerWidth < 768 ) {
					// キャプションの表示アニメーション完了後
					self.$caption.one('animationend.initialClose', function(){
						// 3秒後に閉じる
						setTimeout(function(){
							// キャプション閉
							self.$caption.addClass( 'is-close' );
							// このイベントを破棄
							self.$caption.off('animationend.initialClose');
						}, 3000);
					});
				}

				// マウスオーバーでスライドが一時停止するかどうかの指定を取得
				self.pauseOnHoverFlag = self.$container.slick('slickGetOption', 'pauseOnHover');

				// スライド要素が1点のみの場合、もしくはオートプレイがOFF、マウスオーバーによるスライドの一時停止がない場合はプログレスバーを削除
				if ( slick.slideCount <= 1 || !self.config[ 'autoplay' ] || !self.pauseOnHoverFlag ) {
					self.$base.find( '.progressbar' ).remove();
				}

				// 明示的に1枚目にスライドさせる
				self.$container.slick('slickGoTo', 0, true);
				start();

				// 動画スライダー開始
				function start() {
					//self.$container.trigger( 'afterChange' );// 事前にslickGotoメソッドを使用して1枚目に移動する処理を入れたのでここは不要
					
					// スライダー表示開始
					self.$container.addClass( 'is-ready' );

					// loader消去
					self.$loader.fadeOut(500);
				}

			}, 1000);// ※本来はタイマーは0sで構わないが1枚目が動画の場合にタイミングによって再生できない場合がある。一時しのぎではあるがタイマー1sで様子見
		});

		// slick実行時のパラメータ「centerMode」「variableWidth」をタイプ別に指定。
		// 通常（タイプ【A】）ではfalse。タイプ【B】【C】ではtrue
		var centerMode_flag = false;
		var variableWidth_flag = false;
		if ( this.sliderType == 'b' || this.sliderType == 'c' ) {
			centerMode_flag = true;
			variableWidth_flag = true;
		}

		// slick適用
		this.$container.slick({
			dots:            false,
			autoplay:        this.config[ 'autoplay' ],
			autoplaySpeed:   this.config[ 'autoplaySpeed' ],
			speed:           this.config[ 'speed' ],
			arrows:          true,
            prevArrow:       '<div class="slick-prev"><i class="jeiafont jeia-arrow-left"></i></div>',
            nextArrow:       '<div class="slick-next"><i class="jeiafont jeia-arrow"></i></div>',
			cssEase:         'cubic-bezier(0.87, 0.03, 0.41, 0.9)',
			pauseOnHover:    true,//  マウスオーバーでスライド時間の一時停止
			// タイプ【B】【C】の場合 → item幅をCSSで制御させておいて、ブラウザ幅が広い場合は左右に前後のスライドが見える形にする
			centerMode:      centerMode_flag,
			variableWidth:   variableWidth_flag
		});

		// ドットボタンをslick要素の外側に構成
		if ( this.dotsOuter ) {
			var outerName = 'slick-dotsOuter';
			this.$base.append( $('<div>').addClass( outerName ) );
			this.$container.slick('slickSetOption', {
				appendDots: this.$base.find( '.' + outerName )
			}, true);
		}

		// イベント：リサイズ
		var resizeTimer = false;
		$(window).on('resize', function(){
			if ( resizeTimer !== false ) {
				clearTimeout( resizeTimer );
			}
			resizeTimer = setTimeout(function(){
				// スライダーエリア高さ決定
				//self.fnBaseHeight();
				self.fnSetSize();
				// スライド位置をリセットさせるべくを明示的にカレントスライドに移動実行
				var currentSlideNum = self.$container.slick('slickCurrentSlide');
				self.$container.slick('slickGoTo', currentSlideNum, true);
			}, 100);
		});

		// イベント：beforeChange
		this.$container.on('beforeChange', function(){
			//console.log('beforeChange');
			// スライド時のエフェクト
			self.$sliderItem.addClass( 'is-change' );
			
			// 動画操作：停止
			playPauseVideo('pause');

			// SOUND停止、ボタンリセット
			playPauseVideo('sound-off');
			self.$soundBtn.removeClass( 'sound-on' );

			// プログレスバー停止
			self.$slickCurrent.find( '.progressbar' ).removeClass( 'is-start' );
		});

		// イベント：afterChange
		this.$container.on('afterChange', function(){
			//console.log('afterChange');
			// スライド時のエフェクト（オフ）
			self.$sliderItem.removeClass( 'is-change' );

			// slickカレント要素の取得、メディア種類の取得
			self.$slickCurrent = self.$sliderItem.filter( '.slick-current' );
			self.slickCurrentMedia = self.$slickCurrent.data( 'media' );

			// 動画操作：再生
			playPauseVideo('play');

			// Vimeo動画がBasicプランの動画の場合、音声コントロール不可らしいので再生と同時に音声ミュート操作を実行
			/*
			if ( self.slickCurrentMedia == 'vimeo' ) {
				postMessageToPlayer({ 'method':'setMuted', 'value':1 });
			}
			*/

			// 全キャプションリセット（非表示）
			self.$caption.removeClass( 'is-active' );

			// カレントキャプション取得、表示
			self.$captionCurrent = self.$slickCurrent.find( '.mediaCaption' );
			self.$captionCurrent.addClass( 'is-active' );

			// メディアが画像の場合はSOUNDボタン非表示
			if ( self.slickCurrentMedia == 'img' ) {
				self.$soundBtn.removeClass( 'is-ready' );
			} else {
				self.$soundBtn.addClass( 'is-ready' );
			}

			// スライド表示時間を個別変更（冒頭で実行すると初期表示時にたまに不安定になることがあるので最後に実行）
			changeSlideSpeed();

			// プログレスバースタート（autoplay有効時）
			self.$slickCurrent.find( '.progressbar' ).addClass( 'is-start' );
		});

		// 動画メディア別の操作アクション
		function playPauseVideo(control){
			//console.log('playPauseVideo', self.slickCurrentMedia, control);
			// メディアごとのアクションコマンド
			if ( self.slickCurrentMedia == 'vimeo' ) {
				switch (control) {
					case "play":
						postMessageToPlayer({ 'method':'setMuted', 'value':1 });
						postMessageToPlayer({ 'method':'play', 'value':1 });
					break;
					case "pause":
						postMessageToPlayer({ 'method':'pause', 'value':1 });
					break;
					case "sound-on":
						postMessageToPlayer({ 'method':'setVolume', 'value':0.5 });
					break;
					case "sound-off":
						postMessageToPlayer({ 'method':'setMuted', 'value':1 });
					break;
				}
			} else if ( self.slickCurrentMedia == 'youtube' ) {
				switch (control) {
					case "play":
						postMessageToPlayer({ 'event':'command', 'func':'mute' });
						postMessageToPlayer({ 'event':'command', 'func':'playVideo' });
					break;
					case "pause":
						postMessageToPlayer({ 'event':'command', 'func':'pauseVideo' });
					break;
					case "sound-on":
						postMessageToPlayer({ 'event':'command', 'func':'unMute' });
					break;
					case "sound-off":
						postMessageToPlayer({ 'event':'command', 'func':'mute' });
					break;
				}
			} else if ( self.slickCurrentMedia == 'video' ) {
				var video = self.$slickCurrent.find('video').get(0);
				if ( video == null ) return;
				switch (control) {
					case "play":
						video.play();
					break;
					case "pause":
						video.pause();
					break;
					case "sound-on":
						video.muted = false;
					break;
					case "sound-off":
						video.muted = true;
					break;
				}
			}
		}

		// Web Messaging APIで動画操作をする
		function postMessageToPlayer(action){
			//console.log('postMessageToPlayer', action);
			if (self.$slickCurrent == null || action == null) return;

			// iframe要素のWindowオブジェクト
			var movieWindow = self.$slickCurrent.find( 'iframe' ).get(0).contentWindow;

			//console.log(movieWindow);//←これを入れるとChromeでUncaught DOMException: Blocked a frame with origin "https://artmuseums-kifu.jeia.site" from accessing a cross-origin frame.

			//
			movieWindow.postMessage( JSON.stringify(action), '*' );
		}

		// イベント：SOUNDボタン
		this.$soundBtn.on('click',function(){
			// sound-on class
			$(this).toggleClass( 'sound-on' );

			// SOUND ON/OFF
			if ( $(this).hasClass('sound-on') ) {
				playPauseVideo('sound-on');
			} else {
				playPauseVideo('sound-off');
			}
		});

		// スライド表示時間を個別変更
		/* ※もし初期表示がおかしい事があれば機能をオフ推奨（構成やタイミングによっては1枚目が表示されない（2枚目以降のプロモーションにMP4動画が含まれている場合？）とか表示時間が反映されなかったり） */
		function changeSlideSpeed() {
			//console.log( 'スライド表示時間変更', self.$slickCurrent.data( 'playspeed' ) );
			self.$container.slick( 'slickSetOption', 'autoplaySpeed', self.$slickCurrent.data( 'playspeed' ) );
		}

		// マウスオーバーでスライド表示時間を一時的させる設定の場合は、マウスオーバーでプログレスバーの一時停止処理が必要
		// ※slickの一時停止はどうも再開時はリセットされる様子なので、プログレスバーも一時停止ではなく破棄する形としています。
		this.$container.on({
			'mouseenter': function(){
				self.$slickCurrent.find( '.progressbar' ).removeClass( 'is-start' );
			},
			'mouseleave': function(){
				self.$slickCurrent.find( '.progressbar' ).addClass( 'is-start' );
			}
		});
	};

	// タイプ別スライダー表示
	JeiaMovieSlider.prototype.fnSetSize = function(){
		/*
		 * スライダー全体の高さをどの基準で決定するか？
		 * スライダーの表示スタイルによって基準が変わると思われるので、まず表示スタイルについては以下のパターンがあると思われる。
		 * 【タイプA】全アイテムが同じ縦横比率であり、アイテムは常にエリアのフル幅で表示される。（またはブラウザフル幅）
		 * 【タイプB】全アイテムが同じ縦横比率であり、アイテムの幅か高さが決められており（今回は幅で決定）、ブラウザ幅が広い場合は前後のアイテムがちら見えしている。
		 * 【タイプC】各アイテムがそれぞれ違う縦横比率をもっており、「とある基準」により全アイテム高さが揃えられる。当然、各々のアイテムごとに幅は変化して表示されるので前後のアイテムがちら見えする。
         *  ※タイプBはタイプCで代替できるような気もするが一応、残しておく
		 * 
		 * スマホ時は、【タイプA】～【タイプC】いずれもアイテムの幅はブラウザフル幅表示とし、高さはスマホ用比率spRatioにて決定されるものとする。比率の違うメディアはクリップされる。
		 */
		 switch( this.sliderType ) {
		 	case 'a':
		 		this.fnSetSize_A();
		 		break;
		 	case 'b':
		 		this.fnSetSize_B();
		 		break;
		 	case 'c':
		 		this.fnSetSize_C();
				break;
		 }
	}
	
	// スライダー表示：タイプA
	JeiaMovieSlider.prototype.fnSetSize_A = function(){
		/*
		 * 【タイプA】全アイテムが同じ縦横比率であり、アイテムは常にエリアのフル幅で表示される。
		 * プロモーションエリアがブラウザフル幅ならプロモーション自体もブラウザフル幅で表示。2カラムなどの中にあるコンテンツならそのエリアでフル幅表示。
		 */
		var self = this;
		var baseWidth = this.$base.width();
		
		// デスクトップ・タブレット時（デスクトップ・タブレット用縦横比mainRatioを元に高さが決定）
		if ( window.innerWidth >= 768 ) {
			var itemHeight = baseWidth / this.mainRatio;
			this.$sliderItem.each(function(){
				var $this = $(this);
				$this.css(  {'width': baseWidth, 'height': itemHeight} );
				
				// メディアのサイズと配置
				var $media = $this.find( 'iframe, video, img' );
				self.fnSetMediaSize( $media, self.mainRatio, baseWidth, itemHeight );// 引数：メディア要素, 表示縦横比, アイテム幅, アイテム高さ
			});
		}
		// スマホ時（スマホ用縦横比spRatioを元に高さが決定）
		else {
			var itemHeight = baseWidth / this.spRatio;
			this.$sliderItem.each(function(){
				var $this = $(this);
				$this.css(  {'width': '100vw', 'height': itemHeight} );
				
				// メディアのサイズと配置
				var $media = $this.find( 'iframe, video, img' );
				self.fnSetMediaSize( $media, self.spRatio, baseWidth, itemHeight );// 引数：メディア要素, 表示縦横比, アイテム幅, アイテム高さ
			});
		}
	}

	// スライダー表示：タイプB
	JeiaMovieSlider.prototype.fnSetSize_B = function(){
		/*
		 * 【タイプB】全アイテムが同じ縦横比率であり、アイテムの幅か高さが決められており（今回は幅で決定）、ブラウザ幅が広い場合は前後のアイテムがちら見えしている。
		 */
		var self = this;
		var baseWidth = this.$base.width();
		
		// ブラウザ幅がプロモーション画像作成幅（slideMaxWidth）以上の場合（デスクトップ・タブレット用縦横比mainRatioを元に高さが決定）
		if ( window.innerWidth >= this.slideMaxWidth ) {
			var itemWidth = this.slideMaxWidth;//980;
			var itemHeight = itemWidth / this.mainRatio;
			this.$sliderItem.each(function(){
				var $this = $(this);
				$this.css(  {'width': itemWidth, 'height': itemHeight} );
				
				// メディアのサイズと配置
				var $media = $this.find( 'iframe, video, img' );
				self.fnSetMediaSize( $media, self.mainRatio, itemWidth, itemHeight );// 引数：メディア要素, 表示縦横比, アイテム幅, アイテム高さ
			});
		}
		// プロモーション画像作成幅（slideMaxWidth）未満（スマホ用縦横比spRatioを元に高さが決定）
		else {
			var itemHeight = baseWidth / this.spRatio;
			this.$sliderItem.each(function(){
				var $this = $(this);
				$this.css(  {'width': '100vw', 'height': itemHeight} );
				
				// メディアのサイズと配置
				var $media = $this.find( 'iframe, video, img' );
				self.fnSetMediaSize( $media, self.spRatio, baseWidth, itemHeight );// 引数：メディア要素, 表示縦横比, アイテム幅, アイテム高さ
			});
		}
	}
	
	// スライダー表示：タイプC
	JeiaMovieSlider.prototype.fnSetSize_C = function(){
		/*
		 * 【タイプC】各アイテムがそれぞれ違う縦横比率をもっており、「とある基準」により全アイテム高さが揃えられる。当然、各々のアイテムごとに幅は変化して表示されるので前後のアイテムがちら見えする。
		 * 
		 * 【タイプC】については、「とある基準」は案件ごとに違ってくると思われるが、まず、アイテムの高さを揃えるためには以下の基準が必要と思われる。
		 * スライダー高さが決定されていること。スライダー高さに合わせて各々のアイテムは自身の比率から幅を算出
		 * しかし、これはブラウザ幅が広い場合の話であり、スマホなどブラウザ幅が狭い場合は違う見せ方を加味しなければならない。
		 * パラメータ「slideMaxWidth」でプロモーション画像作成幅を設定しておき、このサイズよりブラウザ幅が広い場合はちら見え表示となるが、
		 * それ未満でありかつタブレット以上の場合、比率はPC画像を維持しつつブラウザ幅に合わせてフル表示
		 * ブラウザ幅が狭いスマホ時では、「基準となる縦横比率」が決定されており全アイテムはその比率を維持してフル幅表示させる、当然、違う比率を持つアイテムはクリップされる形になる。
		 */
		var self = this;
		var baseWidth = this.$base.width();
		
		// ブラウザ幅がプロモーション画像作成幅（slideMaxWidth）以上の場合
		if ( window.innerWidth >= this.slideMaxWidth ) {
				this.$sliderItem.each(function(){
				var $this = $(this);
				var $media = $this.find( 'iframe, video, img' );
				var mediaRatio = $media.data( 'ratio' );
				// 画像メディアの場合：レスポンシブにて異なるアスペクト比の画像が登録される前提なので、その都度、アスペクト比を実ファイルの縦横サイズを取得して算出
				if ( $media.prop('tagName') == 'IMG' ) {
					mediaRatio = $media.get(0).naturalWidth / $media.get(0).naturalHeight;
				}
				
				// アイテム幅を算出
				var itemWidth = mediaRatio * self.sliderHeight + 'px';
				// アイテム高さは固定値
				var itemHeight = self.sliderHeight + 'px';
				// 
				$this.css(  {'width': itemWidth, 'height': itemHeight} );
				$media.css( {'width': itemWidth, 'height': itemHeight, 'position':'static', 'top':0, 'left':0} );// スマホ表示にてメディアがクリップされている可能性があるのでリセットも含ませる
			});
		}
		// タブレット時～プロモーション画像作成幅（slideMaxWidth）未満
		else if (window.innerWidth >= 768 ) {
			var tabletRatio = this.mainRatio;//PC用画像を使うのでPC画像と同じレシオ
			var itemHeight = baseWidth / tabletRatio;
			this.$sliderItem.each(function(){
				var $this = $(this);
				$this.css(  {'width': '100vw', 'height': itemHeight} );
				
				// メディアのサイズと配置
				var $media = $this.find( 'iframe, video, img' );
				self.fnSetMediaSize( $media, tabletRatio, baseWidth, itemHeight );// 引数：メディア要素, 表示縦横比, アイテム幅, アイテム高さ
			});
		}
		// スマホ時（スマホ用縦横比spRatioを元に高さが決定）
		else {
			var itemHeight = window.innerWidth / this.spRatio;
			this.$sliderItem.each(function(){
				var $this = $(this);
				$this.css(  {'width': '100vw', 'height': itemHeight} );
				
				// メディアのサイズと配置
				var $media = $this.find( 'iframe, video, img' );
				self.fnSetMediaSize( $media, self.spRatio, baseWidth, itemHeight );// 引数：メディア要素, 表示縦横比, アイテム幅, アイテム高さ
			});
		}
	}

	// メディアのサイズを決定。比率の違うメディアはクリップされる
	// 引数：メディア要素, 表示縦横比, アイテム幅, アイテム高さ
	JeiaMovieSlider.prototype.fnSetMediaSize = function( $media, itemRatio, itemWidth, itemHeight ){
		//console.log('fnSetMediaSize', $media, itemRatio, itemWidth, itemHeight );
		var mediaRatio = $media.data( 'ratio' );
		
		// 画像メディアの場合：レスポンシブにて異なるアスペクト比の画像が登録される前提なので、その都度、アスペクト比を実ファイルの縦横サイズを取得して算出
		if ( $media.prop('tagName') == 'IMG' ) {
			mediaRatio = $media.get(0).naturalWidth / $media.get(0).naturalHeight;
		}
		
		// メディア比率とスライダーエリア比率を比較してそれぞれの場合でメディアの大きさを調整
		if ( mediaRatio == itemRatio ) {
			//console.log(mediaRatio, itemRatio, '⇒同じ比率');
			var resizeWidth = Math.ceil( itemHeight * mediaRatio );
			$media.css({
				'width': resizeWidth + 'px',
				'height': itemHeight + 'px',
				'position': 'static',
				'top': '0',
				'left': '0'
			});
		} else if ( mediaRatio > itemRatio ) {
			/*
			* メディア比率は、スライダーエリア比率より大きい（＝横にはみ出す）
			* 高さ：100%全表示
			* 幅：高さとメディア比率から算出し左右をクリップ
			*/
			//console.log(mediaRatio, itemRatio, '⇒横にはみ出す → 高さは100%、幅を高さから比率で算出しクリップ');
			var resizeWidth = Math.ceil( itemHeight * mediaRatio );
			$media.css({
				'width': resizeWidth + 'px',
				'height': itemHeight + 'px',
				'position': 'relative',
				'top': '0',
				'left': (itemWidth - resizeWidth) / 2
			});	
		} else {
			/*
			* メディア比率は、スライダーエリア比率より小さい（＝縦にはみ出す）
			* 幅：100%
			* 高さ：幅とメディア比率から算出して上下をクリップ
			*/
			//console.log(mediaRatio, itemRatio, '⇒縦にはみ出す → 幅は100%、高さを幅から比率で算出してクリップ');
			var resizeHeight = Math.ceil( itemWidth / mediaRatio );
			$media.css({
				'width': itemWidth + 'px',
				'height': resizeHeight + 'px',
				'position': 'relative',
				'top': (itemHeight - resizeHeight) / 2,
				'left': '0'
			});
		}
	}
	
	// loader生成
	JeiaMovieSlider.prototype.fnMakeLoading = function(){
		// loaderを生成
		var $loaderImage = $( '<img>' ).attr( 'src', this.config[ 'loaderImage' ] );
		this.$loader = $( '<div class="loader">' ).append( $loaderImage );

		// loder要素をコンテンツに追加
		this.$base.append( this.$loader );
	};

	// SOUNDボタン生成
	JeiaMovieSlider.prototype.fnMakeSoundBtn = function(){
		// SOUNDボタンを生成
		this.$soundBtn = $( '<div class="soundBtn">' );
		
		// SOUNDボタン要素をコンテンツに追加
		if ( this.soundSW ) {
			this.$base.append( $('<div class="soundBtnRole">').append(this.$soundBtn) );
		}

		// ※Google Chromeでは音声ONにすると動画再生が止まってしまう現象が発生することがあるので、仕様として音声機能自体をオフ
		// その際のエラー「Unmuting failed and the element was paused instead because the user didn't interact with the document before」
		//this.$soundBtn.hide();
		// ↓
		// Twig側にて、iframe要素にあらかじめ「allow = "autoplay"」をつけておくと安定するのかも？機能ポリシーの絡み？
	};
	
});
